// src/components/SectionHeading.tsx

// src/components/SectionHeading.tsx

type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  variant?: 'default' | 'light' | 'dark';
};

// We don't use React.FC for better type inference with props
const SectionHeading = ({ title, subtitle, variant = 'default' }: SectionHeadingProps) => {
  const titleColor = variant === 'light' ? 'text-white' : 'text-accent';
  const subtitleColor = variant === 'light' ? 'text-gray-300' : 'text-text-secondary';

  return (
    <div className="mb-4 text-left">
      {/* Main Title */}
      <h2 className={`text-2xl font-semibold leading-tight md:text-3xl ${titleColor}`}>
        {title}
      </h2>

      {/* Decorative Underline */}
      <div className="mt-2 h-0.5 w-10 rounded-full bg-primary/70" />

      {/* Subtitle */}
      {subtitle && (
        <p className={`${subtitleColor} mt-2 max-w-xl text-sm leading-6 md:text-base`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
